/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import {
  Button,
  Chip,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import React, { useEffect } from "react";
import { CustomTheme, Theme } from "../../../../types/customTheme";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import { INTEGER_NUMBER_PATTERN } from "../../../../utils/consts";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
    base: {
      padding: "12px 12px 0 12px",
      [theme.breakpoints.up("sm")]: {
        padding: "16px 16px 0 16px",
      },
      borderRadius: 4,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      borderRadius: "8px 8px 0 0",
      border: `1px solid ${theme.palette.background.entity_border}`,
      padding: 8,
    },
    actionsWrapper: {
      padding: "16px 16px",
      display: "flex",
      justifyContent: "center",
    },
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
        color: theme.palette.custom.orange.contrastText,
      },
    },
    datePickerStyle: {
      [`& fieldset`]: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border}`,
        cursor: "pointer",
      },
      "& .MuiPickersClockPointer-pointer": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "& .MuiPickersClockNumber-clockNumberSelected": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
  }),
);

export interface DiscountInfoNodeProps {
  register: any;
  errors: any;
  handleOpenProductsAddModal: any;
  selectedWrapperIdList: any;
  isMembersEmpty: any;
  selectedOfferType: any;
}

/* Create, delete, and update discount information and users can view all discount information. */
const FirstTwoTypesGroup: React.FunctionComponent<DiscountInfoNodeProps> = ({
  register,
  errors,
  handleOpenProductsAddModal,
  selectedWrapperIdList,
  isMembersEmpty,
  selectedOfferType,
}) => {
  const [selectedProducts, setSelectedProducts] = React.useState<any>([]);
  useEffect(() => {
    let products: any = [];
    Object.values(selectedWrapperIdList).map((product: any) => {
      const data =
        product.memberType === "ITEM" ? product.memberId : product.memberType;
      products.push(data);
    });

    setSelectedProducts(products);
  }, [selectedWrapperIdList]);
  const classes = useStyles();
  const theme: CustomTheme = useTheme();
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {selectedOfferType === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ? (
            <>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Buy (number of qualifying items)
              </Typography>
              <Typography variant="caption" style={{ paddingTop: "12px" }}>
                Number of full-price items that must be in the basket before the
                offer applies. (Example: in “Buy 2 get 1 free”, this would be
                2.)
              </Typography>
            </>
          ) : selectedOfferType === "FIXED_PRICE_FOR_X_ITEMS" ? (
            <>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Number of items to qualify for fixed price
              </Typography>
              <Typography variant="caption" style={{ paddingTop: "12px" }}>
                Total number of items the customer must select to receive the
                fixed price (e.g. “Pick any 3 for £10”).
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Number of items required from this group
              </Typography>
              <Typography variant="caption" style={{ paddingTop: "12px" }}>
                Defines how many items the customer must choose from this group
                to qualify for the offer. (Example: choose 2 from starters, 1
                from mains, 1 from drinks.)
              </Typography>
            </>
          )}
          <TextfieldDefault
            id="requiredPick"
            name="requiredPick"
            type="number"
            label=""
            style={{
              border: `1px solid ${theme.palette.background.entity_border}`,
            }}
            inputRef={register({
              required: "Required Pick is required.",
              pattern: {
                value: INTEGER_NUMBER_PATTERN,
                message: "Invalid limit entered",
              },
              min: {
                value: 1,
                message: "Required Pick greater than 0",
              },
            })}
          />
          {errors.requiredPick ? (
            <ValidationMessage message={errors.requiredPick.message} />
          ) : (
            ""
          )}
        </Grid>

        {/* <Grid item xs={12}>
          <div
            style={{
              marginTop: "12px",
            }}
          >
            <div
              style={{
                width: "100%",
                overflowX: "auto",
              }}
            >
             
              <Autocomplete
                options={[]}
                multiple
                size={"small"}
                color="inherit"
                freeSolo
                style={{ width: "100%" }}
                disableClearable
                fullWidth
                disabled
                classes={{ root: classes.autoComplete }}
                value={selectedProducts}
                renderTags={(value, props) =>
                  value.map((option, index) => (
                    <Chip
                      label={option}
                      style={{ marginRight: "8px", marginTop: "4px" }}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    multiline
                    label=""
                    {...params}
                    size="medium"
                  />
                )}
              />
            </div>
            {isMembersEmpty && (
              <ValidationMessage message={"Members can not be empty"} />
            )}
          </div>
        </Grid> */}

        {/* <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            style={{ textTransform: "none" }}
            color="secondary"
            autoFocus
            onClick={handleOpenProductsAddModal}
          >
            {"Select Members"}
          </Button>
        </Grid> */}
      </Grid>
    </>
  );
};

export default FirstTwoTypesGroup;
